export const formatAiScore = (report) => {
  const score = Number(report?.percentage);
  return !report?.error && Number.isFinite(score) ? `${Math.round(score)}%` : "N/A";
};
